export const RESOLUTION_DAYS_OFFSET = 5;
export const DESCRIPTION_DAYS_OFFSET = 15;
